import { render } from "./document_preview.html?vue&type=template&id=99a4ea8a&external"
import script from "./document_preview.js?vue&type=script&lang=js&external"
export * from "./document_preview.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__